
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#1a1a1a] text-white">
      <div className="px-4 sm:px-6 lg:px-20 py-12 sm:py-16 lg:py-20">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 lg:gap-12 mb-12 sm:mb-16">
            {/* Brand */}
            <div>
              <h3 className="text-xl sm:text-2xl font-bold mb-3 sm:mb-4">Jawsthe</h3>
              <p className="text-xs sm:text-sm text-white/60 leading-relaxed">
                Premium tools for daily discipline. Build better habits, see better results.
              </p>
            </div>

            {/* Shop */}
            <div>
              <h4 className="text-xs sm:text-sm font-semibold uppercase tracking-wider mb-3 sm:mb-4">Shop</h4>
              <ul className="space-y-2 sm:space-y-3">
                <li>
                  <Link to="/product/jawline-support-strap" className="text-xs sm:text-sm text-white/60 hover:text-white transition-colors cursor-pointer">
                    Jawline Support Strap
                  </Link>
                </li>
                <li>
                  <a href="#" className="text-xs sm:text-sm text-white/60 hover:text-white transition-colors cursor-pointer">
                    All Products
                  </a>
                </li>
              </ul>
            </div>

            {/* Support */}
            <div>
              <h4 className="text-xs sm:text-sm font-semibold uppercase tracking-wider mb-3 sm:mb-4">Support</h4>
              <ul className="space-y-2 sm:space-y-3">
                <li>
                  <a href="#" className="text-xs sm:text-sm text-white/60 hover:text-white transition-colors cursor-pointer">
                    FAQ
                  </a>
                </li>
                <li>
                  <a href="#" className="text-xs sm:text-sm text-white/60 hover:text-white transition-colors cursor-pointer">
                    Shipping & Returns
                  </a>
                </li>
                <li>
                  <a href="#" className="text-xs sm:text-sm text-white/60 hover:text-white transition-colors cursor-pointer">
                    Contact Us
                  </a>
                </li>
                <li>
                  <a href="#" className="text-xs sm:text-sm text-white/60 hover:text-white transition-colors cursor-pointer">
                    Track Order
                  </a>
                </li>
              </ul>
            </div>

            {/* Company */}
            <div>
              <h4 className="text-xs sm:text-sm font-semibold uppercase tracking-wider mb-3 sm:mb-4">Company</h4>
              <ul className="space-y-2 sm:space-y-3">
                <li>
                  <a href="#" className="text-xs sm:text-sm text-white/60 hover:text-white transition-colors cursor-pointer">
                    About Us
                  </a>
                </li>
                <li>
                  <a href="#" className="text-xs sm:text-sm text-white/60 hover:text-white transition-colors cursor-pointer">
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a href="#" className="text-xs sm:text-sm text-white/60 hover:text-white transition-colors cursor-pointer">
                    Terms of Service
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="pt-6 sm:pt-8 border-t border-white/10">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-white/40 text-center sm:text-left">
                © 2024 Jawsthe. All rights reserved. | <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-white/60 transition-colors cursor-pointer">Website Builder</a>
              </p>
              <div className="flex items-center gap-4">
                <a href="#" className="text-white/40 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-instagram-line text-lg sm:text-xl"></i>
                </a>
                <a href="#" className="text-white/40 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-facebook-line text-lg sm:text-xl"></i>
                </a>
                <a href="#" className="text-white/40 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-twitter-x-line text-lg sm:text-xl"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
